<template>
    <el-dialog title="Clone List View"
               :visible.sync="showForm"
               :close-on-click-modal="false">

        <h3>Name</h3>
        <input type="text" class="form-control" v-model="name"></input>

        <h3 style="margin-top: 50px;">Who sees this list view?</h3>
        <div class="cd-section">
            <el-radio label="public" v-model="availability">All users can see this list view</el-radio>
        </div>
        <div class="cd-section">
            <el-radio label="private" v-model="availability">Only I can see this list view</el-radio>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="save()">Save</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: [
            'show',
            'view_id'
        ],
        data() {
            return {
                name: '',
                availability: 'public'
            };
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            }
        },
        methods: {
            save() {
                return axios.post(url(`admin/views/clone`), {
                        view_id: this.view_id,
                        name: this.name,
                        availability: this.availability
                    }).then((response) => {
                        this.$emit('updated', response.data);
                        this.showForm = false;
                    });
            }
        }
    }
</script>

<style scoped>
</style>